import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {}
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    }
  },

  actions: {
    async loadItems ({ commit }) {
      try {
        // console.log('Elenco Comunicazioni')
        let rs = await axios.get('/api/comunicazioni')
        // console.log('rs', rs)
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/comunicazioni/${id}`)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async countOpen ({ commit }) {
      try {
        let rs = await axios.get(`/api/comunicazioni`, { params: { op: 'contaAperte' } })
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    }

  }
}
